import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap"
import logoDark from "../../assets/images/logo-dark.png"
import logoLight from "../../assets/images/logo-light.png"
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from "reselect"
import withRouter from "components/Common/withRouter"
import { IntroScreen } from "./intro-screen"
import SnackbarComponent from "components/SnackBar"
import { useFormik } from "formik"
import * as Yup from "yup"
import { userForgetPassword } from "../../store/actions"
import "../../newcomponents/index.css"
import PrimaryButton from "newcomponents/primary-button"
import { ArrowForward } from "@mui/icons-material"
import MailOutlineIcon from "@mui/icons-material/MailOutline"
import "../../newcomponents/index.css"
const ForgetPasswordPage = props => {
  document.title = "Forget Password | AeraVue"
  const [err, setErr] = React.useState("")
  const [success, setSuccess] = React.useState("")
  const dispatch = useDispatch()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Enter a valid email")
        .required("Please Enter Your Email"),
    }),
    onSubmit: values => {
      dispatch(userForgetPassword(values, props.history))
    },
  })

  const selectForgotPasswordState = state => state.ForgetPassword
  const ForgotPasswordProperties = createSelector(
    selectForgotPasswordState,
    forgetPassword => ({
      forgetError: forgetPassword.forgetError,
      forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
    }),
  )
  const { forgetError, forgetSuccessMsg } = useSelector(
    ForgotPasswordProperties,
  )

  return (
    <React.Fragment>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <Container
        fluid
        className="min-vh-100 d-flex flex-column primary-bg"
        style={{
          fontFamily: "Inter",
          backgroundImage: `url('/circle1.svg'), url('/circle2.svg')`,
          backgroundPosition: "bottom left, top right",
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundSize: "24%, 24%",
        }}
      >
        <Row className="flex-grow-1">
          {/* Intro (desktop only) */}
          <Col lg={6} className="d-none d-lg-flex align-items-center">
            <IntroScreen
              buttonText="Sign In"
              onClick={() => props.router.navigate("/login")}
            />
          </Col>

          {/* Form */}
          <Col
            lg={6}
            className="d-flex align-items-center justify-content-center"
            style={{
              padding: "40px",
            }}
          >
            <div className="w-100" style={{ maxWidth: "470px" }}>
              <Card
                style={{
                  borderRadius: "20px",
                  padding: "20px 0px",
                }}
                className="shadow-sm border-0"
              >
                <CardBody>
                  <div className="text-center mb-4">
                    <h2
                      style={{
                        fontSize: "32px",
                        fontWeight: 400,
                        color: "#050409",
                        fontFamily: "Inter",
                      }}
                    >
                      Forgot <span style={{ fontWeight: 700 }}>Password</span>
                    </h2>
                    <p className="text-muted mb-0">
                      Enter your email and we’ll send you instructions.
                    </p>
                  </div>

                  {forgetError && (
                    <Alert color="danger" className="mt-3">
                      {forgetError}
                    </Alert>
                  )}
                  {forgetSuccessMsg && (
                    <Alert color="success" className="mt-3">
                      {forgetSuccessMsg}
                    </Alert>
                  )}

                  <form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <div className="mb-3">
                      <Label
                        htmlFor="email"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#050409",
                          fontFamily: "Inter",
                        }}
                      >
                        EMAIL
                      </Label>

                      {/* Wrapper with error border */}
                      <div
                        className="position-relative"
                        style={{
                          padding: "8px",
                          border:
                            validation.touched.email && validation.errors.email
                              ? "1px solid #ef4444" // red border if error
                              : "1px solid #d1d5db", // default grey
                          borderRadius: "8px",
                        }}
                      >
                        <MailOutlineIcon
                          style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#2990DF",
                          }}
                        />
                        <Input
                          id="email"
                          name="email"
                          type="email"
                          placeholder="hello@mrzul.com"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          style={{
                            paddingLeft: "44px",
                            border: "none", // remove default border
                            boxShadow: "none", // remove bootstrap shadow
                            fontFamily: "Inter",
                          }}
                        />
                      </div>

                      {/* Error text outside wrapper */}
                      {validation.touched.email && validation.errors.email && (
                        <div
                          style={{
                            color: "#ef4444",
                            fontSize: "13px",
                            marginTop: "4px",
                          }}
                        >
                          {validation.errors.email}
                        </div>
                      )}
                    </div>
                    <div className="d-flex justify-content-center mt-4">
                      <PrimaryButton
                        type="submit"
                        style={{
                          padding: "15px 30px",
                        }}
                        onClick={() => console.log("clicked")}
                        icon={<ArrowForward />}
                      >
                        Reset Password
                      </PrimaryButton>
                    </div>
                  </form>
                  <div className="text-center mt-4">
                    <p className="inter secondary-color ">
                      Remember it?{" "}
                      <Link to="/login" className="primary-color underline-link inter semibold-font">
                        Sign In
                      </Link>
                    </p>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
